import 'ui-core/widgets/slideshow/js/slideshow';

(function () {
    var slider = UX.slider;

    slider.set.autoHeight = function () {
        var autoHeight = slider.$slider.closest('.autoheight-slider').data('autoheight');
        if (autoHeight !== undefined) {
            return autoHeight;
        } else {
            return false;
        }
    };

    slider.on.sliderBeforeInit = function ($slider) {
        if ($slider.closest('.epress-journals__slider').length) {
            $slider
                .children()
                .sort(function () {
                    return Math.round(Math.random()) - 0.5;
                })
                .each(function () {
                    $(this).appendTo($slider);
                });
        }
    };
})();
